import { InjectionToken, Injectable } from '@angular/core';
import { Dictionary } from '../../infra/common/localization/types';

export const LOCALIZED_MENU_ITEM_TITLE_SYMBOL = Symbol('LOCALIZED_MENU_ITEM_TITLE');
export interface MenuItem {
    id?: string; // for backward compatibility
    code: number;
    titleKey: string;
    icon?: string;
    /** Fontawesome Icon name. */
    faIcon?: string;
    children?: MenuItem[];
    permission?: string;
    path?: string;
}

export type MenuItems = MenuItem[];

@Injectable()
export class Subsystem {
    id: string;
    titleKey?: string;
    icon?: string;

    /** Fontawesome Icon name. */
    faIcon?: string;
    menuItems?: MenuItem[];
    dictionaries?: Dictionary[];
}

export const SUBSYSTEMS_ROUTES = [];
